module.exports = __webpack_public_path__ + "media/images/common/header_menu_nav-4009a6e7f79b46fb2e1dc14b74957a3a.png";